import { axiosInstance } from '@/rest'

const buildSearchParams = (params = {}) => {
  const searchParams = new URLSearchParams()
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return
    if (Array.isArray(value)) {
      value.forEach((v) => searchParams.append(key, v))
    } else {
      searchParams.append(key, value)
    }
  })
  return searchParams
}

const createNewslettersApi = () => {
  return {
    /**
     * List newsletters in the catalog (admin-only)
     * @param {Object} params { provider_name, active, limit, offset }
     */
    list: (params = {}) => {
      const searchParams = buildSearchParams(params)
      return axiosInstance.get(
        `v2/subaccounts/newsletters?${searchParams.toString()}`
      )
    },

    /**
     * Register a new newsletter in the catalog (admin-only)
     * @param {Object} body { provider_name, name, active }
     */
    create: (body) => axiosInstance.post(`v2/subaccounts/newsletters`, body),

    /**
     * Update a newsletter row in the catalog
     * @param {string} id
     * @param {Object} body { provider_name, name, active }
     */
    update: (id, body) =>
      axiosInstance.patch(`v2/subaccounts/newsletters/${id}`, body),
  }
}

const newslettersApi = createNewslettersApi()

export { newslettersApi }
